import {layoutTypes} from 'features/layout/redux';
import {ICloseSubDialogAction} from 'features/layout/redux/actions';
import {take} from 'redux-saga/effects';

export function* takeDialogResult<T>(dialogName: string) {
   let result: ICloseSubDialogAction<T>;
   do {
      result = yield take(layoutTypes.CLOSE_SUB_DIALOG);
   } while (result.payload?.dialogType !== dialogName);

   return result;
}
